import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const InventorySummaryStep2 = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <div className="inner-content row">
          <div className="container d-flex flex-wrap">
            <div class="shadowclass">
              <p>
                Like a great dish, it all starts with the ingredients until you
                make it all of the way to the menu.
              </p>
              <p>
                Take full advantage of GoGMGo by centralizing all of your
                ingredients, recipes, and menu items in this module.{" "}
              </p>
              <ul className="sm-list">
                <li>
                  Start by going to the <strong>Ingredients</strong> sub-section
                  in Inventory Settings and add all of the ingredients ordered
                  via your suppliers.{" "}
                </li>
                <li>
                  Once the base ingredients have been added, go to the Recipes
                  sub-section inInventory Settings and re-create the digital
                  version of your recipes by linking your ingredients and their
                  quantities to a given recipe.
                </li>
                <li className="d-flex">
                  <p className="me-4">
                  After all ingredients and recipes have been setup, be sure to
                  go to the </p> 
                  <strong>Menu Items</strong> 
                  <p className="ms-2">sub-section in Inventory
                  Settings and setup your menu. This will help the system
                  understand how raw ingredient costs translate to the end
                  product sold to customers so GoGMGo can:</p>
                  <ul className="sm-list ms-4">
                    <li>
                      Calculate expected inventory given transaction volumes
                    </li>
                    <li>Determine menu pricing and perform margin analysis</li>
                    <li>Highlight to management top cost contributors </li>
                  </ul>
                </li>
              </ul>

              <p>Don’t give away profits with low margin menu items, simply open the Menu Pricing function once the ingredients, recipes, and menu items have all been entered.</p>
            </div>

            <div className="row mx-0 w-100">
              <div class="btns d-flex justify-content-end py-4 col-12 px-0">
                <button type="Submit"> Next </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default InventorySummaryStep2;
